import { UploadLandingScreen } from './UploadLandingScreen'
import { UploadCSVModal } from './UploadCSVPanel'
import { UploadReviewModal } from './UploadReviewPanel'
import { UploadDuplicateScreen } from './UploadDuplicateScreen'
import { UploadSuccessPayload } from '../Module'

import { ManualTransactionModel } from '@/reducers/admin/allTransactions.slice'
import { UploadDuplicateGroup } from './duplicateHelpers'

export interface UploadScreenProps {
  onUploadComplete?: (_payload: {
    success: boolean
    data?: UploadSuccessPayload[]
  }) => void
  goToScreenWithData: (_payload: { index: number; data?: ScreenData }) => void
  finishFlow: () => void
  data?: ScreenData
}

export default [
  UploadLandingScreen,
  UploadCSVModal,
  UploadReviewModal,
  UploadDuplicateScreen,
]

export interface ScreenData {
  validTransactions?: Array<ManualTransactionModel>
  duplicateGroups?: UploadDuplicateGroup[]
  spreadsheetFile?: File
  models?: ManualTransactionModel[]
}
